import {ApiUrls} from 'shared/config/model/urls';

import {useDispatch} from 'react-redux';

import {portIncidentAPI} from 'features/port/api/portIncidentAPI';
import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {validatePortBatchEditFields} from 'features/port/lib/portBatchEditFields';
import {
    buildPortBatchOperationRequest,
    getPortBatchOperationsDefaults,
    PortBatchOperationsFormValues,
} from 'features/port/lib/portMonitorFormHelper';
import {useMonitorBatchOperationsForm, IMonitorBatchOperationsFormState, isBatchDeleteAction} from 'entities/monitor';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

import {usePortMonitorSelection} from './usePortMonitorSelection';

interface IUsePortMonitorBatchOperationsFormParams {
    actionValue?: string,
    handleClose: () => void,
    onSuccess?: () => void,
}

export const usePortMonitorBatchOperationsForm = ({
    actionValue,
    handleClose,
    onSuccess,
}: IUsePortMonitorBatchOperationsFormParams): IMonitorBatchOperationsFormState<PortBatchOperationsFormValues> => {
    const {selectedIds} = usePortMonitorSelection();
    const dispatch = useDispatch<TypedDispatch>();

    const invalidate = (action: string | undefined, ids: string[]) => {
        dispatch(portMonitorAPI.util.invalidateTags([{type: 'PortMonitor', id: 'LIST'}, 'SummaryPortMonitors']));

        if (!isBatchDeleteAction(action)) {
            ids.forEach(uuid => {
                dispatch(portMonitorAPI.util.invalidateTags([{type: 'PortMonitor', id: uuid}]));
            });
        }

        if (action !== 'tags') {
            dispatch(portIncidentAPI.util.invalidateTags([{type: 'PortIncident', id: 'LIST'}, 'SummaryPortIncident']));
        }

        dispatch(fetchMe());
    };

    return useMonitorBatchOperationsForm<PortBatchOperationsFormValues>({
        actionValue,
        handleClose,
        onSuccess,
        selectedIds,
        getDefaultValues: (user, freeTariff) =>
            getPortBatchOperationsDefaults({freeTariff, emailConfirmed: !!user?.email_confirmed}),
        getUrl: (action) => ApiUrls.PORT_MONITORS_BATCH_ACTION(action ?? ''),
        buildRequest: buildPortBatchOperationRequest,
        invalidate,
        validateEdit: validatePortBatchEditFields,
    });
};

export default usePortMonitorBatchOperationsForm;
